import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, useHistory } from 'react-router';
import { completedRoutes } from '../../../common/constants';
import { Container, Hidden } from '@material-ui/core';
import './places-grid.scss';
import { useTranslation } from 'react-i18next';
import AdminPlaceInfo from '../AdminPlaceInfo/AdminPlaceInfo';
import IsMobileContext from '../../../common/IsMobileContext';
import { changeErrorPopupState } from '../../../store/uiSlice';

const ContentSwitch = (props) => {
  const { desktopOption, content } = props;

  return (
    <Switch>
      <Route path={`${completedRoutes.adminPlaceInfoWithoutId}/:placeId`}>
        <AdminPlaceInfo />
      </Route>
      {desktopOption &&
      <Route>
        {content}
      </Route>
      }
    </Switch>
  );
};

function PlacesGrid(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const isMobileDesign = useContext(IsMobileContext);
  const { places, hasPlaces, placesError, changeErrorPopupState } = props;

  if (!hasPlaces) {
    return <Redirect to={completedRoutes.switchUserType} />;
  }

  const handleClick = (placeId) => () => {
    history.push(completedRoutes.adminPlaceInfo(placeId), { placeId });
  };

  if (placesError) {
    console.error(placesError);
    changeErrorPopupState({ isOpen: true, error: {}, type: 'default' });
  }

  const content = (
    <Container className="places-grid-cnt">
      <div>
        <h2>{t('placesGrid.header')}</h2>
        {places.map((i) => {
          const { name, address, balance, likengo_id: placeId } = i;
          return (
            <div className="places-grid-item" key={placeId} onClick={handleClick(placeId)}>
              <span className="name">{name}</span>
              <span className="address">{address}</span>
              <span>{t('placesGrid.balance')}:{' '}
                <span className="rubble">{balance}</span>
              </span>
            </div>
          )
        })}
      </div>
      <footer className="add-info">
        <span>{t('placesGrid.footer1')}</span>
        <span>{t('placesGrid.footer2')} <a href="mailto:tasks@likengo.ru">tasks@likengo.ru</a></span>
      </footer>
    </Container>
  );

  return (
    <>
      <Hidden mdUp>
        {content}
      </Hidden>
      <ContentSwitch desktopOption={!isMobileDesign} content={content} />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    places: state.places.data,
    placesError: state.places.error,
    hasPlaces: state.places.data.length !== 0,
  }
};

const actionCreators = {
  changeErrorPopupState,
};

export default connect(mapStateToProps, actionCreators)(PlacesGrid);
